import { datadogRum } from '@datadog/browser-rum';

export const RUM_CONTEXTS = {
  USER: 'user',
  TEAM: 'team',
  CUSTOMER: 'customer',
  SANDBOX: 'sandbox',
} as const;

type RumContexts = typeof RUM_CONTEXTS[keyof typeof RUM_CONTEXTS];

export function updateViewContext(
  context: RumContexts,
  data: Record<string, string | boolean | number> | null = null,
): void {
  datadogRum.setViewContextProperty(context, data);
}

export function resetAllViewContexts(): void {
  for (const context in RUM_CONTEXTS) {
    updateViewContext(context as RumContexts, null);
  }
}
